import type { PageEntity, PageEntityKind } from "./pageContext";

export type ConversationSubject = {
  kind: PageEntityKind;
  id: string;
  name?: string;
  step?: { key: string; label?: string };
};

export type AnsweredOn = Omit<ConversationSubject, "step">;

export const subjectOfPage = (entity: PageEntity, name: string | undefined): ConversationSubject => ({
  kind: entity.kind,
  id: entity.id,
  ...(name ? { name } : {}),
  ...(entity.step ? { step: entity.step } : {}),
});

export const subjectAwayFromPage = (
  subject: ConversationSubject | null | undefined,
  pageEntity: Pick<PageEntity, "id"> | null | undefined,
): ConversationSubject | null => (subject && subject.id !== pageEntity?.id ? subject : null);

export const isAnsweredElsewhere = (
  answeredOn: AnsweredOn | undefined,
  viewedEntity: Pick<PageEntity, "id"> | null | undefined,
): answeredOn is AnsweredOn => !!answeredOn && !!viewedEntity && answeredOn.id !== viewedEntity.id;

const INDEXED_TITLE_KEYS = ["title", "name"] as const;

export const indexedEntityTitle = (entity: Record<string, unknown> | undefined): string | undefined => {
  for (const key of INDEXED_TITLE_KEYS) {
    const value = entity?.[key];
    if (typeof value === "string" && value.trim()) return value;
  }
  return undefined;
};

export const withKnownName = (
  answeredOn: AnsweredOn | undefined,
  nameOf: (id: string) => string | undefined,
): AnsweredOn | undefined => {
  if (!answeredOn || answeredOn.name?.trim()) return answeredOn;
  const name = nameOf(answeredOn.id);
  return name?.trim() ? { ...answeredOn, name } : answeredOn;
};
